"use client";

import { initErrorMom } from "@kenkaiiii/error-mom";

// The project key is write-only (submit errors, read nothing), so committing
// it is safe — same model as a Sentry DSN. Env vars override when present.
const server = process.env.NEXT_PUBLIC_ERROR_MOM_SERVER ?? "https://error-mom-production-68b7.up.railway.app";
const projectKey = process.env.NEXT_PUBLIC_ERROR_MOM_PROJECT_KEY ?? "em_ingest_qiDUFG53ZOKPSc2ULUw5K9r8vh0Dtj9NXYCChuL51iA";
const release = process.env.NEXT_PUBLIC_ERROR_MOM_RELEASE ?? "0.1.0";

export const errorMom = initErrorMom({
  server,
  projectKey,
  environment: process.env.NEXT_PUBLIC_ERROR_MOM_ENVIRONMENT ?? "production",
  release,
});
